import { UploadId } from '../upload';

export interface IProcessVideoOutput {
    uploadId: UploadId;
    videoUrl: string;
}

/**
 * Legacy video format constants, used by the legacy builder, the legacy upload service and
 * the mobile app.
 *
 * New media template (content builder) work should use the `WEB_SAFE_VIDEO_*` and
 * `CONVERTIBLE_VIDEO_*` constants in `features-video-conversion-core` instead, which distinguish between
 * what a browser can play and what we are able to normalise.
 */
export const SUPPORTED_VIDEO_EXTENSIONS = Object.freeze(['mp4', 'mov', 'webm']);

export const SUPPORTED_VIDEO_MIME_TYPES = Object.freeze(['video/mp4', 'video/quicktime']);
